import React from 'react';
import headerStyles from '../styles/header.module.scss'
 
 
const Logo = () => (
    <h3 className={headerStyles.logo_white}>felixgonzalo</h3> 
    
);


export default Logo
